import { Parent_Type_Enum } from '@risksmart-app/web-graphql-client/generated/graphql';
import type { FC } from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { ObjectToolbarConfig } from 'src/blocks/object-toolbar';
import { ObjectToolbar } from 'src/blocks/object-toolbar';
import ControlledTabs from 'src/components/controlled-tabs';
import { PageLayout } from 'src/layouts';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import useTabs from '@/hooks/useTabs';

const Page: FC = () => {
  const { t } = useTranslation(['common']);
  const title = t('risks.create_title');
  const objectToolbarEnabled = useIsFeatureFlagEnabled('object_toolbar');
  const toolbarConfig: ObjectToolbarConfig = useMemo(
    () => ({ header: { title }, save: true }),
    [title]
  );
  const tabs = useTabs({
    parentType: Parent_Type_Enum.Risk,
    parent: undefined,
    hrefRoot: '/risks/create',
    disabled: true,
  });

  return (
    <PageLayout
      title={title}
      // Object-level toolbar (CUS-152) — flag-gated. The create surface has no
      // relocated actions; the toolbar renders the title plus the Save disc /
      // Cancel X, whose state is published by the create form (RiskCreateTab →
      // RiskForm with `publishToolbarState`) via the toolbar bridge store.
      headerOverride={
        objectToolbarEnabled ? (
          <ObjectToolbar config={toolbarConfig} />
        ) : undefined
      }
    >
      <ControlledTabs
        tabs={tabs}
        variant={'container'}
        parentType={Parent_Type_Enum.Risk}
        disableSettings
      />
    </PageLayout>
  );
};

export default Page;
